/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs */

const en_svc_rag_knowledge_assistants_execute_output7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working assistant`)
};

const ar_svc_rag_knowledge_assistants_execute_output7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مساعد يعمل`)
};

const bn_svc_rag_knowledge_assistants_execute_output7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কার্যকর অ্যাসিস্ট্যান্ট`)
};

const de_svc_rag_knowledge_assistants_execute_output7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionierender Assistent`)
};

const es_svc_rag_knowledge_assistants_execute_output7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistente funcional`)
};

const fr_svc_rag_knowledge_assistants_execute_output7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistant fonctionnel`)
};

const pt_svc_rag_knowledge_assistants_execute_output7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistente funcional`)
};

const zh_svc_rag_knowledge_assistants_execute_output7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用的助手`)
};

const tr_svc_rag_knowledge_assistants_execute_output7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çalışan asistan`)
};

const ru_svc_rag_knowledge_assistants_execute_output7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рабочий ассистент`)
};

const pl_svc_rag_knowledge_assistants_execute_output7 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Działający asystent`)
};

/**
* | output |
* | --- |
* | "Working assistant" |
*
* @param {Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_execute_output7 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Execute_Output7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_execute_output7(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_execute_output7(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_execute_output7(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_execute_output7(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_execute_output7(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_execute_output7(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_execute_output7(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_execute_output7(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_execute_output7(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_execute_output7(inputs)
	return en_svc_rag_knowledge_assistants_execute_output7(inputs)
});
export { svc_rag_knowledge_assistants_execute_output7 as "svc_rag-knowledge-assistants_EXECUTE_output" }